import React, {forwardRef} from "react";
import axios from "axios";
import {EXPORT_EXCELL, EXPORT_PDF, SEARCH_FICHES} from "../../api/Api";
import fileDownload from "js-file-download";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import BootstrapLoadingButton from "./BootstrapLoadingButton";
import FicheList from "../Modules/Fiches/FicheList";
import TableActions from "./Table/TableActions";
import {get} from "../../utils/helpers";
import Pagination from "@material-ui/lab/Pagination";
import TableColumnHeader from "./Table/TableColumnHeader";
import {makeStyles} from "@material-ui/styles";


const useStyles = makeStyles(
    (theme) => {
        return {
            tableHeader: {
                color: '#B5B5C3',
                fontSize: '0.9rem',
                textTransform: 'uppercase',
                fontWeight: 600,
                letterSpacing: '0.1rem',
            },
        }
    }
);

//les colonnes automatiques

const Table = React.forwardRef(
    (props, forwadedRef) => {

        const {title, subtitle, columns, actions, assets, dataProvider, renderRows, onSearchStateChangeCallback, renderToolbar, renderCustomToolbar} = props;

        const classes = useStyles();

        const isLoadingAsset = React.useMemo(() => {

            const items = Object.values(assets);
            console.log('items', items)

            for (let i = 0; i < items.length; i++) {

                if (!items[i])
                    continue;

                if (items[i].isLoading)
                    return true;

            }

            return false;
        }, [assets])

        const [isSearching, setIsSearching] = React.useState(false);
        const [isLoadingPage, setIsLoadingPage] = React.useState(false);
        const [isExporting, setIsExporting] = React.useState(false);
        const [searchResultPagined, setSearchResultPagined] = React.useState({});
        const [formValues, setFormValues] = React.useState();
        const [searchResultPageState, setSearchResultPageState] = React.useState({currentPage: 0, totalPages: 0})

        const [columnOrder, setColumnOrder] = React.useState({
            column: undefined,
            mode: undefined
        })

        const [isCreatingFiche, setIsCreatingFiche] = React.useState(false);
        const [enregistrementUnderEdition, setFicheUnderEdition] = React.useState();

        React.useEffect(() => {
            if (onSearchStateChangeCallback)
                onSearchStateChangeCallback(isSearching)
        }, [isSearching])

        // const [searchValues,setSearchValues] = React.useState(initialSearchValues);

        React.useImperativeHandle(forwadedRef, () => ({
            searchFiches(filters) {

                console.log('imperative search items');

                searchItems({
                    ...formValues,
                    ...filters
                })
            },
            reloadItems() {
                console.log('Table items should be reloaded')
                searchItems({}, 1, true)
            }
        }))

        React.useEffect(
            () => {
                searchItems();
            }, []
        )

        function onFormSubmit(values) {
            setFormValues(values);
            if (values != formValues)
                setSearchResultPagined({});
            searchItems(values);
        }

        function onPageChange(event, page) {
            searchItems(formValues, page);
        }


        function onOrderChange(column, mode) {

            console.log(column, mode)

            setColumnOrder({column, mode});

        }

        function onNewFicheClicked() {
            setIsCreatingFiche(true);
        }

        function goToFicheActif() {

        }


        function onFicheUpdated(newFiche) {
            setSearchResultPagined(
                {
                    ...searchResultPagined,
                    [searchResultPageState.currentPage]: searchResultPagined[searchResultPageState.currentPage].map(
                        item => {
                            if (newFiche.id != item.id)
                                return item;

                            return newFiche;
                        }
                    )
                }
            )
        }

        function onFicheCreated(enregistrement) {
            setIsCreatingFiche(false);
            onFormSubmit({});
        }


        function onFicheUpdated(enregistrement) {
            setSearchResultPagined(
                {
                    ...searchResultPagined,
                    [searchResultPageState.currentPage]: searchResultPagined[searchResultPageState.currentPage].map(
                        item => {
                            if (enregistrement.id != item.id)
                                return item;

                            return enregistrement;
                        }
                    )
                }
            )
            setFicheUnderEdition();
        }


        async function searchItems(values, page = 1, forceReload = false) {

            // if (searchResultPagined[page] && /* values ===  filter: formValues && */ !forceReload) {
            //     setSearchResultPageState({...searchResultPageState, currentPage: page})
            //     return;
            // }

            try {

                setIsSearching(true);

                if (page > 1)
                    setIsLoadingPage(true);

                const {count, currentPage, totalPages, datas} = await dataProvider.getPageItems(page, values);

                setSearchResultPagined({
                    ...searchResultPagined,
                    [page]: datas
                })

                setSearchResultPageState({
                    currentPage: currentPage,
                    totalPages,
                    count
                })

                setIsLoadingPage(false);
                setIsSearching(true);

            } catch (e) {
                console.log(e);
            } finally {
                setIsSearching(false);
            }


        }

        async function onExportExcelClicked() {

            try {

                setIsExporting(true);

                const response = (await axios.get(
                    EXPORT_EXCELL,
                    {
                        responseType: 'blob',
                        params: {
                            ...formValues
                        }
                    }
                ));

                fileDownload(response.data, `PGT_${moment().format('DD_MM_YYYY_hh_mm')}.xlsx`);
            } catch (e) {
                console.log(e);
            } finally {
                setIsExporting(false);
            }


        }

        async function onExportPDFClicked() {

            try {

                setIsExporting(true);

                const response = (await axios.get(
                    EXPORT_PDF,
                    {
                        responseType: 'blob',
                        params: {
                            ...formValues
                        }
                    }
                ));

                fileDownload(response.data, `PGT_${moment().format('DD_MM_YYYY_hh_mm')}.pdf`);
            } catch (e) {
                console.log(e);
            } finally {
                setIsExporting(false);
            }


        }

        return (
            <>

                {
                    isLoadingAsset && (
                        <CircularProgress size={16} disableShrink/>
                    )
                }

                {
                    !isLoadingAsset && (
                        <div className="card card-custom gutter-b">
                            <div className="card-header flex-wrap border-0 pt-6 pb-0">
                                <div className="card-title">
                                    <h3 className="card-label">{title}
                                        <span className="d-block text-muted pt-2 font-size-sm">{subtitle}</span>
                                    </h3>
                                </div>
                                <div className="card-toolbar">
                                    <div className="dropdown dropdown-inline mr-2">

                                        {
                                            renderToolbar && renderToolbar()
                                        }

                                        {
                                            renderCustomToolbar && renderCustomToolbar()
                                        }


                                        <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right">

                                            <ul className="navi flex-column navi-hover py-2">
                                                <li className="navi-header font-weight-bolder text-uppercase font-size-sm text-primary pb-2">Choose
                                                    an option:
                                                </li>
                                                <li className="navi-item">
                                                    <a href="#" className="navi-link">
																<span className="navi-icon">
																	<i className="la la-print"></i>
																</span>
                                                        <span className="navi-text">Print</span>
                                                    </a>
                                                </li>
                                                <li className="navi-item">
                                                    <a href="#" className="navi-link">
																<span className="navi-icon">
																	<i className="la la-copy"></i>
																</span>
                                                        <span className="navi-text">Copy</span>
                                                    </a>
                                                </li>
                                                <li className="navi-item">
                                                    <a href="#" className="navi-link">
																<span className="navi-icon">
																	<i className="la la-file-excel-o"></i>
																</span>
                                                        <span className="navi-text">Excel</span>
                                                    </a>
                                                </li>
                                                <li className="navi-item">
                                                    <a href="#" className="navi-link">
																<span className="navi-icon">
																	<i className="la la-file-text-o"></i>
																</span>
                                                        <span className="navi-text">CSV</span>
                                                    </a>
                                                </li>
                                                <li className="navi-item">
                                                    <a href="#" className="navi-link">
																<span className="navi-icon">
																	<i className="la la-file-pdf-o"></i>
																</span>
                                                        <span className="navi-text">PDF</span>
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>

                                    </div>


                                </div>
                            </div>
                            <div className="card-body">

                                <div className="mt-10 mb-5 collapse" id="kt_datatable_group_action_form">
                                    <div className="d-flex align-items-center">
                                        <div className="font-weight-bold text-danger mr-3">Selected
                                            <span id="kt_datatable_selected_records">0</span>records:
                                        </div>
                                        <div className="dropdown mr-2">
                                            <button type="button" className="btn btn-primary btn-sm dropdown-toggle"
                                                    data-toggle="dropdown">Update status
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-sm">
                                                <ul className="nav nav-hover flex-column">
                                                    <li className="nav-item">
                                                        <a href="#" className="nav-link">
                                                            <span className="nav-text">Pending</span>
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a href="#" className="nav-link">
                                                            <span className="nav-text">Delivered</span>
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a href="#" className="nav-link">
                                                            <span className="nav-text">Canceled</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <button className="btn btn-sm btn-danger mr-2" type="button"
                                                id="kt_datatable_delete_all">Delete
                                            All
                                        </button>
                                        <button className="btn btn-sm btn-success" type="button" data-toggle="modal"
                                                data-target="#kt_datatable_fetch_modal">Fetch Selected Records
                                        </button>
                                    </div>
                                </div>


                                <div
                                    className="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded table-responsive"
                                >
                                    <table className="table" style={{overflow: 'scroll'}}>
                                        <thead className="datatable-head">


                                        <tr className="datatable-row" style={{left: 0, whiteSpace: 'nowrap'}}>

                                            {
                                                columns.map(
                                                    (column, index) => {
                                                        return (
                                                            <th key={index}
                                                                className={` ${classes.tableHeader}`}

                                                            >

                                                                {
                                                                    !column.order && (
                                                                        <span
                                                                            style={{minWidth: 120,display: 'block'}}>{column.label.toUpperCase()}</span>
                                                                    )
                                                                }

                                                                {
                                                                    column.order && (
                                                                        <TableColumnHeader
                                                                            style={{minWidth: 120,display: 'block'}}
                                                                            column={column.order}
                                                                            mode={columnOrder.column === column.order ? columnOrder.mode : undefined}
                                                                            onChangeMode={onOrderChange}>{column.label.toUpperCase()}</TableColumnHeader>
                                                                    )
                                                                }

                                                            </th>
                                                        )
                                                    }
                                                )
                                            }


                                            {
                                                actions.length > 0 && (
                                                    <th className="datatable-cell-left datatable-cell dataktable-cell-sort">
                                                        <span style={{width: 120}}>ACTIONS</span>
                                                    </th>
                                                )
                                            }

                                        </tr>
                                        </thead>
                                        <tbody className="datatable-body">

                                        {
                                            searchResultPagined && searchResultPagined[searchResultPageState.currentPage] && searchResultPagined[searchResultPageState.currentPage].map(
                                                (item, index) => {

                                                    if (renderRows)
                                                        return renderRows(item);

                                                    return (
                                                        <tr key={index} className="datatable-row" style={{left: 0}}>

                                                            {
                                                                columns.map(
                                                                    (column, index) => {
                                                                        return (
                                                                            <td
                                                                                className="daktatable-cell"><span
                                                                                style={{minWidth: 120,display: 'block'}}>

                                                                            {
                                                                                column.itemKey && (
                                                                                    get(item, column.itemKey)
                                                                                )
                                                                            }

                                                                                {
                                                                                    column.render && (
                                                                                        column.render(item, assets)
                                                                                    )
                                                                                }

                                                                        </span>
                                                                            </td>
                                                                        )
                                                                    }
                                                                )
                                                            }

                                                            {
                                                                actions.length > 0 && (
                                                                    <td className="datatkable-cell-left datatablke-cell"
                                                                        data-field="Actions"
                                                                        data-autohide-disabled="false"
                                                                        aria-label="null">
                                                                        <TableActions actions={actions} item={item}/>
                                                                    </td>
                                                                )
                                                            }
                                                        </tr>
                                                    );
                                                }
                                            )
                                        }

                                        </tbody>
                                    </table>
                                    <div className="datatable-pager datatable-paging-loaded">
                                        <div className="datatable-pager-nav my-2 mb-sm-0">

                                            <div className={'position-relative'}>

                                                <Pagination color={'primary'} count={searchResultPageState.totalPages}
                                                            page={searchResultPageState.currentPage}
                                                            onChange={onPageChange}/>

                                            </div>
                                        </div>
                                        {/*<div className="datatable-pager-info my-2 mb-sm-0">*/}
                                        {/*    <div className="dropdown bootstrap-select datatable-pager-size"><select*/}
                                        {/*        className="selectpicker datatable-pager-size" title="Select page size"*/}
                                        {/*        data-width="60px"*/}
                                        {/*        data-container="body" data-selected="10">*/}
                                        {/*        <option className="bs-title-option" value=""></option>*/}
                                        {/*        <option value="5">5</option>*/}
                                        {/*        <option value="10">10</option>*/}
                                        {/*        <option value="20">20</option>*/}
                                        {/*        <option value="30">30</option>*/}
                                        {/*        <option value="50">50</option>*/}
                                        {/*        <option value="100">100</option>*/}
                                        {/*    </select>*/}
                                        {/*        <button type="button" tabIndex="-1"*/}
                                        {/*                className="btn dropdown-toggle btn-light"*/}
                                        {/*                data-toggle="dropdown" role="combobox" aria-owns="bs-select-5"*/}
                                        {/*                aria-haspopup="listbox" aria-expanded="false"*/}
                                        {/*                title="Select page size">*/}
                                        {/*            <div className="filter-option">*/}
                                        {/*                <div className="filter-option-inner">*/}
                                        {/*                    <div className="filter-option-inner-inner">10</div>*/}
                                        {/*                </div>*/}
                                        {/*            </div>*/}
                                        {/*        </button>*/}
                                        {/*        <div className="dropdown-menu ">*/}
                                        {/*            <div className="inner show" role="listbox" id="bs-select-5"*/}
                                        {/*                 tabIndex="-1">*/}
                                        {/*                <ul className="dropdown-menu inner show" role="presentation"></ul>*/}
                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*    <span className="datatable-pager-detail">Showing 41 - 50 of 350</span>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>

                            </div>
                        </div>
                    )
                }

            </>
        )
    }
)

export default Table;